'use client';

import { Question } from '@phosphor-icons/react';
import { cn } from '@/lib/utils';

export type AskUserQuestionOutput = {
  success?: boolean;
  displayed?: boolean;
  question?: string;
  options?: string[];
  error?: string;
};

export function AskUserQuestionCard({
  output,
  onAnswer,
  disabled,
}: {
  output: AskUserQuestionOutput;
  onAnswer: (option: string) => void;
  disabled?: boolean;
}) {
  const question = output.question?.trim();
  if (!question) return null;

  const options = (output.options ?? []).filter((option) => option.trim().length > 0);

  return (
    <section className="my-3 rounded-xl border border-violet-500/25 bg-violet-500/[0.05] px-4 py-3">
      <div className="flex items-start gap-3">
        <div className="grid size-9 shrink-0 place-items-center rounded-lg border border-violet-400/25 bg-violet-500/10 text-violet-300">
          <Question weight="duotone" className="size-5" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-medium text-foreground">{question}</p>
          {options.length > 0 ? (
            <div className="mt-2.5 flex flex-wrap gap-2">
              {options.map((option) => (
                <button
                  key={option}
                  type="button"
                  disabled={disabled}
                  onClick={() => onAnswer(option)}
                  className={cn(
                    'rounded-full border px-3 py-1.5 text-xs transition-colors',
                    disabled
                      ? 'cursor-default border-border/50 bg-muted/20 text-muted-foreground/60'
                      : 'border-violet-400/25 bg-violet-500/[0.06] text-foreground/85 hover:border-violet-400/50 hover:bg-violet-500/15 hover:text-foreground',
                  )}
                >
                  {option}
                </button>
              ))}
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
}
